import { Directive, effect, inject, Injectable, input } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MessageService } from '@progress/kendo-angular-l10n';

type SliderDirection = 'ltr' | 'rtl';

@Injectable()
class SliderDirectionMessageService extends MessageService {
  private readonly parentMessageService = inject(MessageService, { optional: true, skipSelf: true });
  private direction: SliderDirection = 'ltr';

  constructor() {
    super();
    this.parentMessageService?.changes.pipe(takeUntilDestroyed()).subscribe(() => this.notifyDirection());
  }

  override get(key: string): string | undefined {
    return this.parentMessageService?.get(key);
  }

  setDirection(direction: SliderDirection): void {
    this.direction = direction;
    this.notifyDirection();
  }

  private notifyDirection(): void {
    this.notify(this.direction === 'rtl');
  }
}

@Directive({
  selector: 'kendo-slider[cueSliderDirection]',
  providers: [SliderDirectionMessageService, { provide: MessageService, useExisting: SliderDirectionMessageService }],
})
export class KendoSliderDirectionDirective {
  private readonly messageService = inject(SliderDirectionMessageService);

  readonly cueSliderDirection = input<SliderDirection>('ltr');

  constructor() {
    effect(() => this.messageService.setDirection(this.cueSliderDirection()));
  }
}
